import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useClickSensitivePropertyGroupLink = () => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    (item: SelectItem) => {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: item.value,
            type: EntityDrawerType.SENSITIVE_PROPERTY_GROUP,
          },
        })
      );
    },
    [dispatch, projectId]
  );
};
